export default {
  isBusy: state => id => !!state.busyCategoryIds[id],
  syncedCount: state => state.categories.filter(c => c.status === 'synced').length,
  notSyncedCount: state => state.categories.filter(c => c.status === 'not_synced').length,
  errorCount: state => state.categories.filter(c => c.status === 'error').length,
}
